import React, { useState, useEffect } from 'react';
import VideoServices from '../../../services/VideoServices';

function VideoUpdate({ video, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    title: '',
    link: '',
    
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 

  useEffect(() => {
    if (video) {
      setFormValues({
        title: video?.title || '',
        link: video?.link || '',
      });
      
    }
  }, [video]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await VideoServices.updateVideo(video.id, formValues);
      alert('Video updated successfully');
      onSuccess();
    } catch (error) {
      console.error('Failed to update Video', error);
      alert('Failed to update Video');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Video Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-9 col-md-6">
                        <div className="input-field">
                          <label>Title</label>
                          <input type="text" name="title" className="form-control" value={formValues.title} onChange={handleInputChange} placeholder="New video" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-6">
                        <div className="input-field">
                          <label>Link</label>
                          <input type="text" name="link" className="form-control" value={formValues.link} onChange={handleInputChange} placeholder="New link" />
                        </div>
                      </div>
                      
                    </div>
                    <button className="submit-green-btn">Update Video</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoUpdate;
